import Items from '../../components/Items/items'
import Schedule from '../../components/schedule/schedule'
import Specializations from '../../components/specializations/specialization'
import Graduations from '../../components/graduations/graduations'
import CompanyStatitics from '../../components/statistics'

export default {
  Items,
  Schedule,
  Specializations,
  Graduations,
  CompanyStatitics
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/gadget/resources/components.js